var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12903 19.2431H10.8065C11.3979 19.2431 11.9355 18.7469 11.9355 18.1404V1.15789C11.9355 0.49624 11.4516 0 10.8065 0H1.12903C0.483871 0 0 0.49624 0 1.15789V18.0852C0 18.7469 0.483871 19.2431 1.12903 19.2431ZM1.39785 15.7694H10.4839C10.7527 15.7694 10.914 15.5489 10.914 15.2732V1.4336C10.914 1.21304 10.7527 0.992493 10.4839 0.992493H1.39785C1.1828 0.992493 0.967743 1.15791 0.967743 1.4336V15.3283C0.967743 15.5489 1.12903 15.7694 1.39785 15.7694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96774 18.36C6.50221 18.36 6.93548 17.9156 6.93548 17.3675C6.93548 16.8193 6.50221 16.375 5.96774 16.375C5.43327 16.375 5 16.8193 5 17.3675C5 17.9156 5.43327 18.36 5.96774 18.36Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83855 4.4106H2.04285C1.88156 4.4106 1.6665 4.24519 1.6665 4.02464C1.6665 3.80409 1.82779 3.63867 2.04285 3.63867H9.78478C9.99984 3.63867 10.1611 3.80409 10.1611 4.02464C10.2149 4.24519 10.0536 4.4106 9.83855 4.4106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83855 6.61568H2.04285C1.82779 6.61568 1.6665 6.45027 1.6665 6.22971C1.6665 6.00916 1.82779 5.84375 2.04285 5.84375H9.78478C9.99984 5.84375 10.1611 6.00916 10.1611 6.22971C10.2149 6.39513 10.0536 6.61568 9.83855 6.61568Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83855 8.76607H2.04285C1.82779 8.76607 1.6665 8.60066 1.6665 8.38011C1.6665 8.15955 1.88156 7.99414 2.04285 7.99414H9.78478C9.99984 7.99414 10.1611 8.15955 10.1611 8.38011C10.2149 8.60066 10.0536 8.76607 9.83855 8.76607Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83855 10.9165H2.04285C1.88156 10.9165 1.6665 10.751 1.6665 10.5305C1.6665 10.3099 1.82779 10.1445 2.04285 10.1445H9.78478C9.99984 10.1445 10.1611 10.3099 10.1611 10.5305C10.2149 10.751 10.0536 10.9165 9.83855 10.9165Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83856 13.0669H4.03211C3.81705 13.0669 3.65576 12.9014 3.65576 12.6809C3.65576 12.4603 3.81705 12.2949 4.03211 12.2949H9.78479C9.99985 12.2949 10.1611 12.4603 10.1611 12.6809C10.2149 12.9014 10.0536 13.0669 9.83856 13.0669Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8493 13.0669H2.04285C1.82779 13.0669 1.6665 12.9014 1.6665 12.6809C1.6665 12.4603 1.82779 12.2949 2.04285 12.2949H2.8493C3.06435 12.2949 3.22564 12.4603 3.22564 12.6809C3.22564 12.9014 3.06435 13.0669 2.8493 13.0669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCampaignIcon);
export default __webpack_public_path__ + "static/media/marketing_campaign_icon.e6f8ad5deae2c11a530d2aaa1a68449d.svg";
export { ForwardRef as ReactComponent };